import PropTypes from 'prop-types';
import get from 'lodash.get';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import QuoteIcon from 'dibs-icons/exports/legacy/Quote';
import styles from './styles/ShoppingWithQuote.scss';

function ShoppingWithQuoteComponent({ shoppingWith }) {
    return (
        <div className={styles.wrapper}>
            <div className={styles.quoteWrapper}>
                <QuoteIcon className={styles.openQuote} />
                <div className={styles.quoteBody}>{get(shoppingWith, 'quote.quoteBody')}</div>
                <QuoteIcon className={styles.closeQuote} />
            </div>
            <img className={styles.image} src={get(shoppingWith, 'quote.image')} />
            <div className={styles.author}>{get(shoppingWith, 'quote.authorName')}</div>
        </div>
    );
}

ShoppingWithQuoteComponent.propTypes = {
    shoppingWith: PropTypes.object.isRequired,
};

export const ShoppingWithQuote = createFragmentContainer(ShoppingWithQuoteComponent, {
    shoppingWith: graphql`
        fragment ShoppingWithQuote_shoppingWith on ShoppingWith {
            quote {
                authorName
                image
                quoteBody
            }
        }
    `,
});
